function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function () {
  function r(t) {
    return "clipboard" in navigator ? navigator.clipboard.writeText(t) : (c(t), Promise.resolve());
  }

  function s(t) {
    var _getSelection;

    var e = l(t);
    return "clipboard" in navigator ? ((_getSelection = getSelection()) !== null && _getSelection !== void 0 && _getSelection.removeAllRanges(), navigator.clipboard.writeText(e)) : (c(e), Promise.resolve());
  }

  function c(t) {
    var e = document.createElement("pre");
    e.style.width = "1px", e.style.height = "1px", e.style.position = "fixed", e.style.top = "50%", e.textContent = t, document.body.append(e), l(e), document.execCommand("copy"), document.body.removeChild(e);
  }

  function l(t) {
    if (t instanceof HTMLInputElement || t instanceof HTMLTextAreaElement || t instanceof HTMLSelectElement) return t.value;
    var e = getSelection(),
        n = document.createRange();
    return n.selectNodeContents(t), e ? (e.removeAllRanges(), e.addRange(n), e.toString()) : "";
  }

  var o = /*#__PURE__*/function (_HTMLElement) {
    _inherits(o, _HTMLElement);

    var _super = _createSuper(o);

    function o() {
      _classCallCheck(this, o);

      return _super.apply(this, arguments);
    }

    _createClass(o, [{
      key: "connectedCallback",
      value: function connectedCallback() {
        this.hasAttribute("tabindex") || this.setAttribute("tabindex", "0"), this.hasAttribute("role") || this.setAttribute("role", "button"), this.onClick = this.onClick.bind(this), this.onFocus = this.onFocus.bind(this), this.onBlur = this.onBlur.bind(this), this.addEventListener("click", this.onClick), this.addEventListener("focus", this.onFocus), this.addEventListener("blur", this.onBlur);
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this.removeEventListener("click", this.onClick), this.removeEventListener("focus", this.onFocus), this.removeEventListener("blur", this.onBlur);
      }
    }, {
      key: "onClick",
      value: function onClick(e) {
        var n = e.currentTarget;
        n instanceof HTMLElement && d(n);
      }
    }, {
      key: "onFocus",
      value: function onFocus(e) {
        e.currentTarget.addEventListener("keydown", a);
      }
    }, {
      key: "onBlur",
      value: function onBlur(e) {
        e.currentTarget.removeEventListener("keydown", a);
      }
    }]);

    return o;
  }( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

  function a(t) {
    if (t.key === " " || t.key === "Enter") {
      var e = t.currentTarget;
      if (!(e instanceof HTMLElement)) return;
      t.preventDefault(), d(e);
    }
  }

  function d(_x) {
    return _d.apply(this, arguments);
  }

  function _d() {
    _d = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(t) {
      var e, n, i;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              e = t.getAttribute("value"), n = t.getAttribute("for");

              if (!e) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return r(e);

            case 4:
              u(t);
              _context.next = 14;
              break;

            case 7:
              if (!n) {
                _context.next = 14;
                break;
              }

              i = document.getElementById(n);

              if (i instanceof HTMLElement) {
                _context.next = 11;
                break;
              }

              return _context.abrupt("return");

            case 11:
              _context.next = 13;
              return s(i);

            case 13:
              u(t);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _d.apply(this, arguments);
  }

  function u(t) {
    t.dispatchEvent(new CustomEvent("clippy-copy:copied", {
      bubbles: !0
    }));
  }

  window.customElements.get("clippy-copy") || (window.ClippyCopyElement = o, window.customElements.define("clippy-copy", o));
})();